import React, { useEffect, useState } from "react";

const Career = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Run once to ensure it's accurate even after initial render
    handleResize();

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  if (isMobile) {
    return (
      <div>
        <div>Mobile</div>
      </div>
    );
  }
  return (
    <div className="page-wrapper">
      <div className="page-hero-text-wrapper">
        <div className="page-hero-text">Career</div>
      </div>
      <div className="page-body-wrapper">
        <div className="career-body-section-wrapper">
          <div className="career-body-wrapper">
            <div className="career-body-text-wrapper">
              <div className="career-body-title">Why Us?</div>
              <div className="career-body-text">
                At S.B. Sharma & Associates, we distinguish ourselves through an
                unwavering commitment to professional excellence and ethical
                standards. Our firm offers a dynamic and collaborative
                environment where talent is nurtured, and growth is encouraged.
                Employees benefit from comprehensive training programs,
                mentorship from industry experts, and opportunities to engage
                with a diverse portfolio of clients. We prioritize work-life
                balance and foster a culture of respect, integrity, and
                continuous improvement—making S.B. Sharma & Associates a
                distinguished place to build a lasting career.
              </div>
            </div>
          </div>
          <div className="career-body-divider" />
          <div className="career-body-wrapper">
            <div className="career-body-text-wrapper">
              <div className="career-body-title">Our Career Vision</div>
              <div className="career-body-text">
                At S.B. Sharma & Associates, we are committed to cultivating a
                workforce of principled professionals dedicated to the highest
                standards of integrity and excellence. Our vision is to foster a
                supportive and empowering environment that promotes continuous
                professional development and enables our team members to
                contribute meaningfully to both client success and the firm’s
                enduring reputation.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Career;
